import { render, staticRenderFns } from "./SelectedRecipientOfferLinks.vue?vue&type=template&id=245c69e4"
import script from "./SelectedRecipientOfferLinks.vue?vue&type=script&lang=ts"
export * from "./SelectedRecipientOfferLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/prototypes/offers/_locales/SelectedRecipientOfferLinks.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fprototypes%2Foffers%2FSelectedRecipientOfferLinks.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports